export default __webpack_public_path__ + "c542edd1a95e92b424b086667f12dd53.png";